import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import DashboardNavigationBar from '@/components/dashboard/navigation-bar/dashboard-navigation-bar';
import Loading from '@/components/loading/loading';
import { GetRiskAnalysisByCancerTypeResponse } from '@/repositories/risk.repository';
import { RiskFactorsBreakdown } from '../common/risk-factor-breakdown/risk-factors-breakdown';
import RiskAnalysisHeader from './components/risk-analysis-header/risk-analysis-header';
import useRiskAnalysisController from './risk-analysis.controller';

export default function RiskAnalysisPage() {
  const { cancersByRiskFactor, cancerTypeRiskDataByCancerType, isLoading, riskAnalysisData, riskFactorsByCancer } =
    useRiskAnalysisController();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <DashboardNavigationBar activeItem="risk-analysis" />
      <RiskAnalysisHeader data={riskAnalysisData as GetRiskAnalysisByCancerTypeResponse} />
      <DashboardLayout containerProps={{ pt: 0, pb: 0 }}>
        <RiskFactorsBreakdown
          riskFactorsByCancer={riskFactorsByCancer}
          cancersByRiskFactor={cancersByRiskFactor}
          cancerTypeRiskDataByCancerType={cancerTypeRiskDataByCancerType}
        />
      </DashboardLayout>
    </>
  );
}
